/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type Roles = typeof Roles[keyof typeof Roles];


export const Roles = {
  User: 'User',
  Admin: 'Admin',
  Anonymous: 'Anonymous',
} as const;
